import {useForm} from 'react-hook-form';
import {Baseline} from 'types';

interface CodebeamerCheckBoxValue {
	CodebeamerTransfer: boolean;
}

export function useBaselineTransferForm(defaultChecked = false) {
	const form = useForm<CodebeamerCheckBoxValue>({
		reValidateMode: 'onSubmit',
		mode: 'onBlur',
		defaultValues: {CodebeamerTransfer: defaultChecked},
	});

	const {control, getValues, setValue, reset} = form;

	// Set value based on selected baselines (for rename dialog)
	const setFromBaselines = (baselines: Baseline[]) => {
		if (!baselines?.length) {
			reset({CodebeamerTransfer: false});
			return;
		}
		if (baselines.length === 1) {
			const flag = baselines[0].transferWorkflow?.transferToCodebeamer ?? false;
			setValue('CodebeamerTransfer', flag, {shouldDirty: false});
		}
	};

	const getStatus = () => getValues('CodebeamerTransfer');

	return {
		control,
		getStatus,
		setFromBaselines,
		setValue,
	};
}
